import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as
  | string
  | undefined;
const isTestMode = import.meta.env.MODE === "test";
const resolvedSupabaseUrl =
  supabaseUrl ?? (isTestMode ? "http://127.0.0.1:54321" : undefined);
const resolvedSupabaseAnonKey =
  supabaseAnonKey ?? (isTestMode ? "test-anon-key" : undefined);

if (!resolvedSupabaseUrl || !resolvedSupabaseAnonKey) {
  console.warn(
    "Missing Supabase env vars: VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY",
  );
}

type SupabaseClient = ReturnType<typeof createClient>;
const allowPlaywrightClientOverride =
  import.meta.env.MODE !== "production" &&
  import.meta.env.VITE_DANGEROUS_E2E_BYPASS_AUTH === "true";

declare global {
  interface Window {
    __PLAYWRIGHT_SUPABASE_CLIENT?: SupabaseClient;
  }

  interface GlobalThis {
    __PLAYWRIGHT_SUPABASE_CLIENT?: SupabaseClient;
  }
}

function resolvePlaywrightClient(): SupabaseClient | undefined {
  if (
    import.meta.env.MODE === "production" ||
    import.meta.env.VITE_DANGEROUS_E2E_BYPASS_AUTH !== "true"
  ) {
    return undefined;
  }
  if (!allowPlaywrightClientOverride) {
    return undefined;
  }
  if (typeof globalThis === "undefined") return undefined;
  const globalWithMock = globalThis as GlobalThis;
  return globalWithMock.__PLAYWRIGHT_SUPABASE_CLIENT;
}

const playwrightClient = resolvePlaywrightClient();
export const supabase =
  playwrightClient ??
  createClient(resolvedSupabaseUrl ?? "", resolvedSupabaseAnonKey ?? "", {
    auth: {
      persistSession: true,
    },
  });
